const API_GET_USER_PROGRAMS_FULL_REQUEST = 'API_GET_USER_PROGRAMS_FULL_REQUEST';
const API_GET_USER_PROGRAMS_FULL_SUCCESS = 'API_GET_USER_PROGRAMS_FULL_SUCCESS';
const API_GET_USER_PROGRAMS_FULL_FAILURE = 'API_GET_USER_PROGRAMS_FULL_FAILURE';

const SELECT_USER_PROGRAMS = 'SELECT_USER_PROGRAMS';
const SELECT_USER = 'SELECT_USER';
const SELECT_USER_THINKTOOL = 'SELECT_USER_THINKTOOL';
const SELECT_USER_VERSION = 'SELECT_USER_VERSION';
const SELECT_ASSESSMENT = 'SELECT_ASSESSMENT';
const SUBMIT_MCQ = 'SUBMIT_MCQ';
const TOGGLE_ASSIGNMENT_VIEW= 'TOGGLE_ASSIGNMENT_VIEW';

const RESET_USER_PROGRAMS = 'RESET_USER_PROGRAMS';
const RESET_SELECTED_CONTENT = 'RESET_SELECTED_CONTENT';
const SELECT_USER_ATTEMPT = 'SELECT_USER_ATTEMPT';
const SELECT_USER_MODULE = 'SELECT_USER_MODULE';

const SET_PROFILE_POPUP = 'SET_PROFILE_POPUP';


const SELECT_ROLLOUT = 'SELECT_ROLLOUT';


const SET_COACH_RATING = 'SET_COACH_RATING';
const SET_COACH_RATING_COMMENT = 'SET_COACH_RATING_COMMENT';
const SET_COACH_RATING_VERSION = 'SET_COACH_RATING_VERSION';
const RESET_COACH_RATING = 'RESET_COACH_RATING';
const SET_COACH_RATING_QUALITY = 'SET_COACH_RATING_QUALITY';
const SET_RATING_DONE = 'SET_RATING_DONE';

export const setRatingDone = payload => ({
  type: SET_RATING_DONE,
  payload,
});

export const setCoachRating = payload => ({
  type: SET_COACH_RATING,
  payload,
});
export const setCoachRatingQuality = payload => ({
  type: SET_COACH_RATING_QUALITY,
  payload,
});
export const setCoachRatingComment = payload => ({
  type: SET_COACH_RATING_COMMENT,
  payload,
});
export const setCoachRatingVersion = payload => ({
  type: SET_COACH_RATING_VERSION,
  payload,
});
export const resetCoachRating = payload => ({
  type: RESET_COACH_RATING,
  payload,
});

export const selectUserVersion = payload => ({
  type: SELECT_USER_VERSION,
  payload,
});
export const setProfilePopup = payload => ({
  type: SET_PROFILE_POPUP,
  payload,
});

export const resetelectedContent = () => ({
  type: RESET_SELECTED_CONTENT,
});

export const selectUserThinkTool = payload => ({
  type: SELECT_USER_THINKTOOL,
  payload,
});

export const selectUserModule = payload => ({
  type: SELECT_USER_MODULE,
  payload,
});

export const selectAssessment = payload => ({
  type: SELECT_ASSESSMENT,
  payload,
});
export const submitMCQ = payload => ({
  type: SUBMIT_MCQ,
  payload,
});
export const toggleAssignmentView= payload => ({
  type: TOGGLE_ASSIGNMENT_VIEW,
  payload,
});


export const selectUser = payload => ({
  type: SELECT_USER,
  payload,
});

export const selectRollout = payload => ({
  type: SELECT_ROLLOUT,
  payload,
});

export const resetUserPrograms = () => ({
  type: RESET_USER_PROGRAMS,
});

export const selectUserPrograms = payload => ({
  type: SELECT_USER_PROGRAMS,
  payload,
});



export const getUserProgramsFullRequest = () => ({
  type: API_GET_USER_PROGRAMS_FULL_REQUEST,
});

export const getUserProgramsFullSuccess = payload => ({
  type: API_GET_USER_PROGRAMS_FULL_SUCCESS,
  payload,
});
export const selectAttempt = payload => ({
  type: SELECT_USER_ATTEMPT,
  payload,
});

export const getUserProgramsFullFailure = payload => ({
  type: API_GET_USER_PROGRAMS_FULL_FAILURE,
  payload,
});

const initialState = {
  selectedVersionId: null,
  selectedThinkToolId: null,
  selectedUserId: null,
  selectedProgramId: null,
  selectedProjectId: null,
  selectedModuleId:null,
  selectedAssessmentId: null,
  selectedRollout:null,
  selectedAttempt:null,
  viewAssignment:null,
  isFetched: false,
  submitMCQ:false,
  fetching: false,
  error: null,
  programs: null,
  showProfile:false,
  coachRating:0,
  coachRatingQuality:0,
  coachRatingComment:'',
  coachRatingVersion:0,
  ratingDone:false
};

export function userProgramsFullReducer(state = initialState, action) {
  switch (action.type) {
    case SET_RATING_DONE:
        return {
          ...state,
          ratingDone: action.payload,
        };
    case SET_COACH_RATING_COMMENT:
        console.log('COMMENT', action.payload)
      return {
        ...state,
        coachRatingComment: action.payload,
  };
  case SET_COACH_RATING_VERSION:

    return {
      ...state,
      coachRatingVersion: action.payload,
    };
  case SET_COACH_RATING:
     
    return {
      ...state,
      coachRating: action.payload,
    };
    case SET_COACH_RATING_QUALITY:
     
        return {
          ...state,
          coachRatingQuality: action.payload,
        };
    case RESET_COACH_RATING:
     
      return {
        ...state,
        coachRating: 0,
        coachRatingQuality: 0,
      };
    case RESET_SELECTED_CONTENT:
      return {
        ...state,
        selectedContentId: null,
      };
    case SET_PROFILE_POPUP:
        return {
          ...state,
          showProfile: action.payload,
        };
    case TOGGLE_ASSIGNMENT_VIEW:
      return {
        ...state,
        viewAssignment: action.payload,
      };
    case SELECT_USER_VERSION:
        
      return {
        ...state,
        selectedVersionId: action.payload,
      };
      case SELECT_USER_MODULE:
        
        return {
          ...state,
          selectedModuleId: action.payload,
        };
        case SELECT_ROLLOUT:
        
          return {
            ...state,
            selectedRollout: action.payload,
          };
      case SELECT_USER_ATTEMPT:
 
        return {
          ...state,
          selectedAttempt: action.payload,
        };
    case SELECT_USER_THINKTOOL:
      return {
        ...state,
        selectedThinkToolId: action.payload,
      };
    case SELECT_ASSESSMENT:
    
      return {
        ...state,
        selectedAssessmentId: action.payload,
      };
      case SUBMIT_MCQ:
      
        return {
          ...state,
          submitMCQ: action.payload,
        };
    case SELECT_USER:
      return {
        ...state,
        selectedUserId: action.payload,
      };
    case RESET_USER_PROGRAMS:
      return {
        ...state,
        selectedProgramId: null,
        isFetched: false,
      };
    case SELECT_USER_PROGRAMS:
      console.log('CALL ME X', action.payload)
      return {
        ...state,
        selectedProjectId: action.payload,
      };
    case API_GET_USER_PROGRAMS_FULL_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_GET_USER_PROGRAMS_FULL_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        programs: action.payload,
      };
    case API_GET_USER_PROGRAMS_FULL_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userProgramsFull.js